import { components, useApi } from "@appretio/api";
import { useMutation } from "@tanstack/react-query";
import { useKeyedSave } from "./useKeyedSave";

type SaveCubeInput = components["schemas"]["SaveCubeInput"];

/**
 * Mutation hook to persist forecast grid data to a cube.
 */
export function useSaveCubeData() {
  const apiClient = useApi();
  const save = useKeyedSave((body: SaveCubeInput & { save_id: string }) =>
    apiClient.POST("/v2/forecast/grid/save", { body })
  );

  return useMutation({
    mutationFn: async (input: Omit<SaveCubeInput, "save_id">) => {
      const response = await save(input);
      if (!response.data?.result) {
        throw new Error("Missing result in save cube data response");
      }
      return response.data.result;
    },
    // The save id decides whether a repeat is safe; useKeyedSave owns it.
    retry: false,
    meta: {
      errorMessage: "Failed to save cube data"
    }
  });
}
